module.exports = __webpack_public_path__ + "media/4x3/mg-67f5922d.svg";